import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.service_checkout_attempt_status_ */
export type ServiceCheckoutAttemptStatusId = string & {
  __brand: 'ServiceCheckoutAttemptStatusId'
}

/** Represents the table public.service_checkout_attempt_status_ */
export default interface ServiceCheckoutAttemptStatusTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<
    ServiceCheckoutAttemptStatusId,
    ServiceCheckoutAttemptStatusId,
    ServiceCheckoutAttemptStatusId
  >

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type ServiceCheckoutAttemptStatus =
  Selectable<ServiceCheckoutAttemptStatusTable>

export type ServiceCheckoutAttemptStatusInitializer =
  Insertable<ServiceCheckoutAttemptStatusTable>

export type ServiceCheckoutAttemptStatusMutator =
  Updateable<ServiceCheckoutAttemptStatusTable>

export const serviceCheckoutAttemptStatusId =
  z.string() as unknown as z.Schema<ServiceCheckoutAttemptStatusId>

export const serviceCheckoutAttemptStatus = z.object({
  id: serviceCheckoutAttemptStatusId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<ServiceCheckoutAttemptStatus>

export const serviceCheckoutAttemptStatusInitializer = z.object({
  id: serviceCheckoutAttemptStatusId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<ServiceCheckoutAttemptStatusInitializer>

export const serviceCheckoutAttemptStatusMutator = z.object({
  id: serviceCheckoutAttemptStatusId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<ServiceCheckoutAttemptStatusMutator>
